import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import {
  ErrorResponse,
  ListResponse,
  Transaction,
  TransactionMethodCategory,
} from 'types';

/** Query string params accepted by the transactions list API. */
export type TransactionsListQueries = {
  status?: Transaction['status'];
  from_date?: string;
  to_date?: string;
  category?: TransactionMethodCategory;
  'transaction_method.category'?: TransactionMethodCategory;
  currency?: string | null;
  current?: number;
  pageSize?: number;
};

function useTransactions({
  queries,
}: {
  queries: TransactionsListQueries;
}): UseQueryResult<ListResponse<Transaction>, ErrorResponse> {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }

  return useQuery([`${url.transactions}${queryParams}`]);
}

export default useTransactions;
